import * as moment from 'moment';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'addDays'
})
export class AddDaysPipe implements PipeTransform {

    transform(
        value: string | Date | null | undefined,
        days: number,
        outputFormat: string = 'YYYY-MM-DD',
        inputFormat: string = 'YYYY-MM-DD'
    ): string | null {
        if (value == null) return null;

        let m: moment.Moment;

        if (typeof value === 'string') {
            // Strict parse as calendar date (no timezone conversion)
            m = moment(value, inputFormat, true);
        } else {
            // Treat Date as a calendar date using its local Y/M/D parts
            // (No conversion to UTC, no shifting)
            m = moment({
                year: value.getFullYear(),
                month: value.getMonth(), // 0-based
                day: value.getDate()
            });
        }

        if (!m.isValid()) return null;

        return m.add(days, 'days').format(outputFormat);
    }

}
